import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
export function ProblemAgitationSection() {
  return <>
      {/* The Problem */}
      <Section data-id="element-119">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-120">
          "My baby only sleeps in my arms."
        </h2>
        <div className="space-y-6 text-lg md:text-xl text-[#f5f0e8] leading-relaxed" data-id="element-121">
          <p data-id="element-122">
            That sentence sounds normal… until it's been true for 12 nights
            straight.
          </p>
          <p data-id="element-123">At first you think it's a phase.</p>
          <p data-id="element-124">Then you start taking shifts.</p>
          <p data-id="element-125">Then you start dreading sunset.</p>
          <p data-id="element-126">
            And then the fear shows up—the quiet one nobody wants to say out
            loud:
          </p>
          <blockquote className="border-l-4 border-[#b8a9c9] pl-6 py-4 my-8 text-[#d4cfc5] italic text-xl md:text-2xl" data-id="element-127">
            "I'm so tired I'm scared I'll fall asleep holding my baby."
          </blockquote>
          <p data-id="element-128">If that's you, I'm not here to hype you up.</p>
          <p data-id="element-129">I'm here to give you something more useful:</p>
          <p className="font-medium text-[#c9a96e]" data-id="element-130">
            A 2am emergency protocol to move from "only sleeps in arms" to safer
            bassinet sleep—using exact sequencing, timing, and a decision ladder
            for what to do when the transfer fails.
          </p>
        </div>
      </Section>

      {/* Why Old Solutions Fail */}
      <Section data-id="element-131">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#faf6f0] mb-8" data-id="element-132">
          Why you keep failing transfers (even when you're doing "everything
          right")
        </h2>
        <div className="space-y-6 text-lg md:text-xl text-[#f5f0e8] leading-relaxed" data-id="element-133">
          <p data-id="element-134">Most sleep advice is built for daylight brains. It sounds like:</p>
          <ul className="list-disc pl-6 space-y-2 text-[#d4cfc5]" data-id="element-135">
            <li data-id="element-136">"Drowsy but awake."</li>
            <li data-id="element-137">"Try a heating pad."</li>
            <li data-id="element-138">"Try a swaddle."</li>
            <li data-id="element-139">"Try shushing."</li>
            <li data-id="element-140">"Try darker."</li>
          </ul>
          <p data-id="element-141">And at 2am, you try all of it. Sometimes all at once.</p>
          <p className="font-bold text-[#faf6f0] text-2xl mt-8" data-id="element-142">
            But nobody tells you the part that actually controls the outcome:
          </p>
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-[#c9a96e] mt-4 mb-6" data-id="element-143">
            The order and the timing.
          </h3>
          <p data-id="element-144">Transfers often fail because of:</p>
          <ul className="space-y-3 mt-4" data-id="element-145">
            <li className="flex items-start" data-id="element-146">
              <span className="text-[#c97a7a] mr-3" data-id="element-147">✕</span>
              <span data-id="element-148">Releasing too early (baby is still too light)</span>
            </li>
            <li className="flex items-start" data-id="element-149">
              <span className="text-[#c97a7a] mr-3" data-id="element-150">✕</span>
              <span data-id="element-151">
                Releasing too abruptly (your hands vanish; containment
                disappears)
              </span>
            </li>
            <li className="flex items-start" data-id="element-152">
              <span className="text-[#c97a7a] mr-3" data-id="element-153">✕</span>
              <span data-id="element-154">Placing head-first (startle + sensory shock)</span>
            </li>
            <li className="flex items-start" data-id="element-155">
              <span className="text-[#c97a7a] mr-3" data-id="element-156">✕</span>
              <span data-id="element-157">
                Skipping the hold-down phase (the bridge between "in your arms"
                and "alone")
              </span>
            </li>
          </ul>
          <p className="mt-8" data-id="element-158">
            So you end up in the worst place: you're working harder, getting
            less sleep, and feeling less safe.
          </p>

          <div className="mt-12 text-center" data-id="element-159">
            <CTAButton data-id="element-160">Get the Emergency Night Protocol — $6.36</CTAButton>
          </div>
        </div>
      </Section>
    </>;
}